const styles = (theme) => ({
  header: {
    height: 'auto',
  },
  title: {
    width: '100%',
    height: '1em',
    fontSize: 20,
    display: 'inline-flex',
    alignItems: 'center',
    flexWrap: 'nowrap',
    flex: 1,
    minWidth: 0,
    fontWeight: 400,
    marginBottom: 43,
    '& div': {
      display: 'inline',
    },
  },
  searchLabel: {
    color: theme.color.grey_8A,
    paddingRight: theme.spacing(5),
    fontSize: 16,
  },
  search: {
    '& fieldset': {
      border: 0,
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 0,
    },
  },
  scrollBox: {
    height: `calc(100% - 115px)`,
    overflow: 'auto',
  },
});

export default styles;
